import { createDeferred } from 'kit/kit-promise';
import { useRef } from 'react';

export const useDeferred = () => {
  const defer = useRef(createDeferred());
  return defer.current;
};
